import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {issuesAppBuilder} from './config/app-builder'
import {createIssuesRoutes} from './routes/create-issues-routes'

// Deferred (function) form so createIssuesRoutes reads the client flag at app registration, not
// module load (unsafe during SSR).
export const issuesApp = issuesAppBuilder.createDataRouterAppFromRoutes(() => createIssuesRoutes(issuesAppBuilder))
registerDataRouterApp(issuesApp)
